import { render, staticRenderFns } from "./PresTagsChart.vue?vue&type=template&id=3e60f700"
import script from "./PresTagsChart.vue?vue&type=script&lang=js"
export * from "./PresTagsChart.vue?vue&type=script&lang=js"
import style0 from "./PresTagsChart.vue?vue&type=style&index=0&id=3e60f700&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports